export class GameAudio {
  private context: AudioContext | null = null;
  private engineGain: GainNode | null = null;
  private engineOscillator: OscillatorNode | null = null;
  private muted = true;

  setMuted(muted: boolean): void {
    this.muted = muted;
    if (this.engineGain) {
      this.engineGain.gain.setTargetAtTime(muted ? 0 : 0.035, this.now(), 0.08);
    }
  }

  get isMuted(): boolean {
    return this.muted;
  }

  async unlock(): Promise<void> {
    if (!this.context) {
      this.context = new AudioContext();
      this.startEngine();
    }

    if (this.context.state === "suspended") {
      await this.context.resume();
    }
  }

  updateEngine(speedRatio: number): void {
    if (!this.context || !this.engineOscillator || !this.engineGain) return;

    const now = this.now();
    this.engineOscillator.frequency.setTargetAtTime(58 + speedRatio * 92, now, 0.08);
    this.engineGain.gain.setTargetAtTime(this.muted ? 0 : 0.022 + speedRatio * 0.03, now, 0.1);
  }

  laneTick(): void {
    this.tone(360, 0.045, "triangle", 0.04);
  }

  bonus(): void {
    this.tone(640, 0.06, "sine", 0.05);
    window.setTimeout(() => this.tone(860, 0.06, "sine", 0.04), 48);
  }

  warning(): void {
    this.tone(160, 0.08, "sawtooth", 0.035);
  }

  crash(): void {
    this.tone(70, 0.22, "sawtooth", 0.09);
  }

  private startEngine(): void {
    if (!this.context) return;

    this.engineOscillator = this.context.createOscillator();
    this.engineGain = this.context.createGain();
    this.engineOscillator.type = "sawtooth";
    this.engineOscillator.frequency.value = 70;
    this.engineGain.gain.value = 0;
    this.engineOscillator.connect(this.engineGain).connect(this.context.destination);
    this.engineOscillator.start();
  }

  private tone(frequency: number, duration: number, type: OscillatorType, volume: number): void {
    if (this.muted || !this.context) return;

    const oscillator = this.context.createOscillator();
    const gain = this.context.createGain();
    const now = this.now();

    oscillator.type = type;
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(volume, now + 0.012);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    oscillator.connect(gain).connect(this.context.destination);
    oscillator.start(now);
    oscillator.stop(now + duration + 0.03);
  }

  private now(): number {
    return this.context?.currentTime ?? 0;
  }
}
